import axios from 'axios';

const auth = axios.create({ baseURL : 'http://sqlserver06.lukos.com.br:9001'});
//onst auth = axios.create({ baseURL: API_BASE_URL });
//const auth = axios.create({ baseURL : 'http://192.168.5.62:9001'});
export default auth;